
"use client";

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

export default function HomePage() {
  const router = useRouter();
  const { currentUser, loading: authContextLoading } = useAuth();
  const [clientReady, setClientReady] = useState(false);

  useEffect(() => {
    setClientReady(true);
  }, []);

  useEffect(() => {
    if (clientReady && !authContextLoading) {
      if (currentUser) {
        router.replace('/dashboard');
      } else {
        router.replace('/login');
      }
    }
  }, [clientReady, currentUser, authContextLoading, router]);

  if (!clientReady || authContextLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // This content will typically not be seen because of the redirect,
  // but it serves as a fallback during the brief moment clientReady is true
  // and authContextLoading is false, before the redirect effect runs.
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
       <LoadingSpinner size="lg" />
    </div>
  );
}
